module.exports = __webpack_public_path__ + "img/1-4.062eb7b2.png";